export class Division {
    id!: string
    name!: string
    sortOrder = 0
    archived = false
    jobTypeIds: string[] = []

    // transient display-only fields populated client-side from the loaded job types
    jobTypeCount?: number
    jobTypeNames?: string
}
